import type { KnowledgeScope } from '../../constants/knowledgeScope'
import { BrowseField } from './BrowseField'
import { CategoryBrowsePanel } from './CategoryBrowsePanel'

type Props = {
  value?: string
  onChange?: (category: string) => void
  scope: KnowledgeScope
  placeholder?: string
  disabled?: boolean
  className?: string
  trigger?: 'hover' | 'click'
}

export function KnowledgeCategoryBrowseField({
  value,
  onChange,
  scope,
  placeholder = '请选择文档类型',
  disabled,
  className,
  trigger = 'hover',
}: Props) {
  const display = value
    ? value.includes('/')
      ? value.split('/').filter(Boolean).join(' / ')
      : value
    : ''

  return (
    <BrowseField
      placeholder={placeholder}
      hidePlaceholder={!value}
      disabled={disabled}
      className={className}
      trigger={trigger}
      panelClassName="app-browse-popover-panel--category"
      panel={<CategoryBrowsePanel scope={scope} value={value} onChange={onChange} />}
    >
      {value ? (
        <span className="app-browse-field-display-text" title={value}>
          {display}
        </span>
      ) : null}
    </BrowseField>
  )
}
